(function () {
  const root = document.querySelector("[data-mkd]");
  if (!root) return;

  const copy = JSON.parse(root.getAttribute("data-copy") || "{}");
  const settings = JSON.parse(root.getAttribute("data-settings") || "{}");
  const proxyUrl = root.getAttribute("data-proxy-url") || "/apps/mayekoo-fundraising/fundraisers";
  const startUrl = root.getAttribute("data-start-url") || "/pages/start-a-mayekoo-fundraiser";
  const enableMostSupported = settings.enableMostSupported === true;
  const showRecentChip = settings.showRecentChip !== false;
  const showNewChip = settings.showNewChip !== false;
  const initialLimit = Number(settings.initialPageSize || 9);
  const recentDays = Number(settings.recentDays || 7);
  const newDays = Number(settings.newDays || 30);
  const closeGoalMinPct = Number(settings.closeGoalMinPct || 70);
  const locale = root.getAttribute("data-locale") || settings.locale || "en";
  const needsLocaleHydration = !/^en(-|$)/i.test(String(locale));

  const S = {
    q: "",
    cause: [],
    country: [],
    region: [],
    organizerType: [],
    includePaused: false,
    quick: null,
    sort: "recommended",
    cursor: 0,
  };

  const $ = (sel) => root.querySelector(sel);
  const $$ = (sel) => [...root.querySelectorAll(sel)];
  const esc = (value) => String(value ?? "").replace(/[&<>"]/g, (char) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
  }[char]));

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency || "USD",
        maximumFractionDigits: 0,
      }).format((cents || 0) / 100);
    } catch {
      return "$" + Math.round((cents || 0) / 100).toLocaleString("en-US");
    }
  }

  function t(key, vars) {
    let value = copy[key] || key;
    Object.entries(vars || {}).forEach(([name, replacement]) => {
      value = value.replaceAll(`{${name}}`, String(replacement));
    });
    return value;
  }

  function pct(item) {
    if (item.goalCents == null || item.goalCents <= 0) return null;
    return Math.round((item.raisedCents / item.goalCents) * 100);
  }

  function byLine(item) {
    const name = (item.organizerDisplayName || item.organizationDisplayName || "").trim();
    return name ? t("card.by", { name: esc(name) }) : t("card.hosted");
  }

  function metaLine(item) {
    if (item.causeDisplayName && item.geographyLabel) {
      return t("card.meta", { cause: esc(item.causeDisplayName), geography: esc(item.geographyLabel) });
    }
    if (item.geographyLabel) return t("card.meta.geography_only", { geography: esc(item.geographyLabel) });
    return "";
  }

  function supporterLine(item) {
    if (!item.supporterCountVerified || item.supporterCount == null) return "";
    if (item.supporterCount === 0) return t("card.supporters.none");
    if (item.supporterCount === 1) return t("card.supporters.one");
    return t("card.supporters", { n: item.supporterCount });
  }

  function imageStyle(url) {
    return url ? ` style="background-image:url('${esc(url)}')"` : "";
  }

  const CAUSE_COPY = {
    "beach-cleanup": "cause.beach_cleanup",
    "clean-water": "cause.clean_water",
    "education-access": "cause.education",
    "end-period-poverty": "cause.period_poverty",
    other: "cause.other",
  };
  const GEO_COPY = {
    GH: "geography.ghana",
    KE: "geography.kenya",
    SS: "geography.south_sudan",
    AFRICA_WIDE: "geography.africa_wide",
  };
  const TYPE_COPY = {
    MAYEKOO: "filter.organizer_type.mayekoo",
    NONPROFIT: "filter.organizer_type.nonprofit",
    INDIVIDUAL_COMMUNITY: "filter.organizer_type.individual",
  };

  function localizeFacets(facets) {
    if (!facets) return facets;
    return {
      cause: (facets.cause || []).map((facet) => ({ ...facet, label: copy[CAUSE_COPY[facet.key]] || facet.label })),
      geography: (facets.geography || []).map((facet) => ({ ...facet, label: copy[GEO_COPY[facet.key]] || facet.label })),
      organizerType: (facets.organizerType || []).map((facet) => ({ ...facet, label: copy[TYPE_COPY[facet.key]] || facet.label })),
    };
  }

  function localizeItem(item) {
    const next = { ...item };
    if (item.causeKey && copy[CAUSE_COPY[item.causeKey]]) next.causeDisplayName = copy[CAUSE_COPY[item.causeKey]];
    const geoKey = item.geographyScope === "AFRICA_WIDE" ? "AFRICA_WIDE" : (item.countryCodes || [])[0];
    if (geoKey && copy[GEO_COPY[geoKey]]) next.geographyLabel = copy[GEO_COPY[geoKey]];
    if (item.handle === "fund-clean-water-africa" && copy["featured.blurb"]) {
      next.featuredBlurb = copy["featured.blurb"];
    }
    if (needsLocaleHydration && item.url && item.url.startsWith("/pages/")) {
      const prefix = /^pt/i.test(String(locale)) ? "/pt" : /^fr/i.test(String(locale)) ? "/fr" : "";
      if (prefix && !item.url.startsWith(`${prefix}/`)) next.url = `${prefix}${item.url}`;
    }
    return next;
  }

  function card(item) {
    const percent = pct(item);
    const over = percent != null && percent >= 100;
    const noGoal = item.goalCents == null || item.goalCents <= 0;
    const pin = item.publicStatus === "PAUSED"
      ? `<span class="pin paused">${esc(t("card.pin.paused"))}</span>`
      : over ? `<span class="pin funded">${esc(t("card.pin.funded"))}</span>` : "";
    const photo = item.imageUrl
      ? `<div class="img"${imageStyle(item.imageUrl)}>${pin}</div>`
      : `<div class="img"><div class="ph">${esc(t("card.no_photo"))}</div>${pin}</div>`;
    let moneyBlock = "";
    if (noGoal) {
      moneyBlock = `<div class="figs"><b>${esc(money(item.raisedCents, item.currency))}</b> ${esc(t("card.raised.no_goal", { raised: "" }).replace("{raised} ", "").replace(" raised", ""))}${esc(t("card.raised.no_goal", { raised: "" }).includes("raised") ? "" : "")}</div><div class="sub">${esc(t("card.no_goal"))}</div>`;
      moneyBlock = `<div class="figs"><b>${esc(money(item.raisedCents, item.currency))}</b> ${esc(t("card.raised.no_goal", { raised: "" }).replace("{raised}", "").trim())}</div><div class="sub">${esc(t("card.no_goal"))}</div>`;
    } else {
      const support = supporterLine(item);
      moneyBlock = `<div class="bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.min(100, percent)}" aria-valuetext="${esc(t("card.over_goal", { pct: Math.min(100, percent) }))}"><b class="${over ? "done" : ""}" style="width:${Math.min(100, percent)}%"></b></div>
        <div class="figs">${esc(t("card.raised", { raised: money(item.raisedCents, item.currency), goal: money(item.goalCents, item.currency) }))}</div>
        ${support || over ? `<div class="sub">${over ? `${esc(t("card.over_goal", { pct: percent }))}${support ? " · " : ""}` : ""}${esc(support)}</div>` : ""}`;
    }
    return `<a class="card" data-handle="${esc(item.handle)}" href="${esc(item.url)}" aria-label="${esc(item.title)}">${photo}
      <div class="b">
        <div class="meta">${metaLine(item)}</div>
        <h3>${esc(item.title)}</h3>
        ${item.translationNotice ? `<p class="sub">${esc(item.translationNotice)}</p>` : ""}
        <div class="by">${byLine(item)}</div>
        ${moneyBlock}
        <div class="cta">${esc(t("card.cta"))} <span aria-hidden="true">→</span></div>
      </div>
    </a>`;
  }

  function featuredMarkup(item) {
    if (!item || settings.showFeatured === false) return "";
    const percent = pct(item);
    const support = supporterLine(item);
    const blurbText = (item.handle === "fund-clean-water-africa" && copy["featured.blurb"]) ? copy["featured.blurb"] : item.featuredBlurb;
    const blurb = blurbText ? `<p>${esc(blurbText)}</p>` : "";
    return `<article class="featured" data-handle="${esc(item.handle)}">
      <div class="img"${imageStyle(item.imageUrl)}></div>
      <div class="body">
        <span class="eyebrow">${esc(t("featured.eyebrow"))}</span>
        <div class="meta">${metaLine(item)}</div>
        <h2>${esc(item.title)}</h2>
        ${item.translationNotice ? `<p class="sub">${esc(item.translationNotice)}</p>` : ""}
        <div class="by">${byLine(item)}</div>
        ${blurb}
        ${item.goalCents > 0 ? `<div class="bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.min(100, percent)}" aria-valuetext="${esc(t("card.over_goal", { pct: Math.min(100, percent) }))}"><b class="${percent >= 100 ? "done" : ""}" style="width:${Math.min(100, percent)}%"></b></div>` : ""}
        <div class="figs">${item.goalCents > 0
          ? esc(t("card.raised", { raised: money(item.raisedCents, item.currency), goal: money(item.goalCents, item.currency) }))
          : esc(t("card.raised.no_goal", { raised: money(item.raisedCents, item.currency) }))}</div>
        ${support ? `<div class="sub" style="margin-bottom:16px">${esc(support)}</div>` : ""}
        <a class="btn primary" href="${esc(item.url)}">${esc(t("featured.cta"))}</a>
      </div>
    </article>`;
  }

  function hasDeliberateDiscovery() {
    return Boolean(
      S.q
      || S.cause.length
      || S.country.length
      || S.region.length
      || S.organizerType.length
      || S.includePaused
      || S.quick
      || S.sort !== "recommended",
    );
  }

  function resetCursor() {
    S.cursor = 0;
    nextCursor = null;
  }

  function queryString(extra) {
    const params = new URLSearchParams();
    params.set("v", "11");
    if (S.q) params.set("q", S.q);
    if (S.cause.length) params.set("cause", S.cause.join(","));
    if (S.country.length) params.set("country", S.country.join(","));
    if (S.region.length) params.set("region", S.region.join(","));
    if (S.organizerType.length) params.set("organizerType", S.organizerType.join(","));
    if (S.includePaused) params.set("includePaused", "true");
    if (S.quick) params.set("quick", S.quick);
    if (S.sort !== "recommended") params.set("sort", S.sort);
    params.set("limit", String(initialLimit));
    params.set("cursor", String(extra && extra.cursor != null ? extra.cursor : S.cursor));
    params.set("recentDays", String(recentDays));
    params.set("newDays", String(newDays));
    params.set("closeGoalMinPct", String(closeGoalMinPct));
    if (locale && !/^en(-|$)/i.test(String(locale))) params.set("locale", String(locale));
    Object.entries(extra || {}).forEach(([key, value]) => {
      if (key === "cursor") return;
      params.set(key, String(value));
    });
    return params;
  }

  function writeUrl() {
    const params = queryString();
    params.delete("v");
    params.delete("limit");
    params.delete("cursor");
    params.delete("recentDays");
    params.delete("newDays");
    params.delete("closeGoalMinPct");
    params.delete("locale");
    const next = `${window.location.pathname}${params.toString() ? `?${params}` : ""}`;
    if (next !== `${window.location.pathname}${window.location.search}`) {
      try {
        history.pushState({ ...S, cursor: 0 }, "", next);
      } catch {
        /* Theme Editor and some preview frames block history writes. */
      }
    }
    syncRobots();
  }

  function syncRobots() {
    const params = new URLSearchParams(window.location.search);
    const filtered = ["q", "cause", "country", "region", "organizerType", "includePaused", "quick", "sort"]
      .some((key) => params.get(key));
    let robots = document.querySelector('meta[name="robots"][data-mkd-seo]');
    if (filtered) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        robots.setAttribute("data-mkd-seo", "true");
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex,follow");
    } else if (robots) {
      robots.remove();
    }
  }

  function readUrl() {
    const params = new URLSearchParams(window.location.search);
    const list = (key) => params.getAll(key).flatMap((value) => String(value).split(",")).map((value) => value.trim()).filter(Boolean);
    S.q = params.get("q") || "";
    S.cause = list("cause");
    S.country = list("country");
    S.region = list("region");
    S.organizerType = list("organizerType");
    S.includePaused = params.get("includePaused") === "true";
    const quick = params.get("quick");
    S.quick = quick === "close" || quick === "recent" || quick === "new" ? quick : null;
    if (S.quick === "recent" && !showRecentChip) S.quick = null;
    if (S.quick === "new" && !showNewChip) S.quick = null;
    const sort = params.get("sort");
    S.sort = sort === "recent" || sort === "close" || sort === "newest" ? sort : "recommended";
    resetCursor();
    const search = $("#q");
    if (search) search.value = S.q;
  }

  function group(title, key, facets) {
    return `<div class="fgroup"><h3>${esc(title)}</h3>${facets.map((facet) => {
      const on = S[key].includes(facet.key);
      return `<label><input type="checkbox" data-f="${key}" value="${esc(facet.key)}" ${on ? "checked" : ""}> ${esc(facet.label)} <span class="cnt">${facet.count}</span></label>`;
    }).join("")}</div>`;
  }

  function filterHTML(data) {
    return group(t("filter.cause"), "cause", data.facets?.cause || [])
      + `<div class="fgroup"><h3>${esc(t("filter.geography"))}</h3>${(data.facets?.geography || []).map((facet) => {
        const key = facet.key === "AFRICA_WIDE" ? "region" : "country";
        const on = S[key].includes(facet.key);
        return `<label><input type="checkbox" data-f="${key}" value="${esc(facet.key)}" ${on ? "checked" : ""}> ${esc(facet.label)} <span class="cnt">${facet.count}</span></label>`;
      }).join("")}</div>`
      + (settings.showPausedFilter === false ? "" : `<div class="fgroup"><h3>${esc(t("filter.status"))}</h3>
          <label><input type="checkbox" data-inc ${S.includePaused ? "checked" : ""}> ${esc(t("filter.include_paused"))}</label>
        </div>`)
      + `<details class="fgroup more"><summary>${esc(t("filter.organizer_type"))}</summary>
          <div style="margin-top:8px">${(data.facets?.organizerType || []).map((facet) => {
            const on = S.organizerType.includes(facet.key);
            return `<label><input type="checkbox" data-f="organizerType" value="${esc(facet.key)}" ${on ? "checked" : ""}> ${esc(facet.label)} <span class="cnt">${facet.count}</span></label>`;
          }).join("")}</div>
        </details>`
      + `<button class="btn ghost sm clearall" data-clear>${esc(t("filter.clear"))}</button>`;
  }

  function activeChips(data) {
    const out = [];
    (data.facets?.cause || []).forEach((facet) => {
      if (S.cause.includes(facet.key)) out.push(["cause", facet.key, facet.label]);
    });
    (data.facets?.geography || []).forEach((facet) => {
      if (S.country.includes(facet.key) || S.region.includes(facet.key)) out.push([facet.key === "AFRICA_WIDE" ? "region" : "country", facet.key, facet.label]);
    });
    (data.facets?.organizerType || []).forEach((facet) => {
      if (S.organizerType.includes(facet.key)) out.push(["organizerType", facet.key, facet.label]);
    });
    if (S.includePaused) out.push(["paused", "true", t("results.including_paused")]);
    if (S.quick === "close") out.push(["quick", "close", t("quick.close")]);
    if (S.quick === "recent") out.push(["quick", "recent", t("quick.recent")]);
    if (S.quick === "new") out.push(["quick", "new", t("quick.new")]);
    if (S.q) out.push(["q", S.q, `“${S.q}”`]);
    if (!out.length) return "";
    return `<div class="active-filters">${out.map(([kind, value, label]) =>
      `<span class="afchip">${esc(label)}<button data-rm="${esc(kind)}:${esc(value)}" aria-label="${esc(t("filter.remove", { label }))}">×</button></span>`
    ).join("")}<button class="btn ghost sm" data-clear>${esc(t("filter.clear_all"))}</button></div>`;
  }

  function sortOptions() {
    const options = [
      ["recommended", t("sort.recommended")],
      ["recent", t("sort.recent")],
      ["close", t("sort.close")],
      ["newest", t("sort.newest")],
    ];
    if (enableMostSupported) options.push(["supported", t("sort.supported")]);
    return options.map(([value, label]) => `<option value="${value}" ${S.sort === value ? "selected" : ""}>${esc(label)}</option>`).join("");
  }

  function moreButtonHtml(loading) {
    return `<div class="loadmore"><button type="button" class="btn ghost" id="more"${loading ? " disabled aria-busy=\"true\"" : ""}>${esc(t("results.load_more"))}</button></div>`;
  }

  let lastItems = [];
  let lastFeatured = null;
  let lastData = null;
  let nextCursor = null;
  let inflight = false;
  let requestSeq = 0;
  let lastError = null;

  function resultHead(data) {
    const total = data.totalCount || 0;
    const nFilters = S.cause.length + S.country.length + S.region.length + S.organizerType.length + (S.includePaused ? 1 : 0) + (S.quick ? 1 : 0);
    const countLabel = total === 1 ? t("results.count", { n: total }) : t("results.count.plural", { n: total });
    return `<div class="reshead">
      <span class="n" aria-live="polite">${esc(countLabel)}</span>
      <button class="mobfilter" id="openDrawer" type="button">${esc(t("filter.button"))}${nFilters ? `<span class="b">${nFilters}</span>` : ""}</button>
      <span class="sp"></span>
      <label class="sub" style="font-size:14px;color:var(--muted)">${esc(t("results.sort"))}
        <select class="sortsel" id="sort">${sortOptions()}</select>
      </label>
    </div>${activeChips(data)}`;
  }

  function emptyHtml() {
    return S.q
      ? `<div class="empty"><b>${esc(t("empty.search.title", { q: S.q }))}</b>${esc(t("empty.search.body"))}<div><button class="btn primary" data-clear style="margin-top:16px">${esc(t("empty.action"))}</button></div></div>`
      : `<div class="empty"><b>${esc(t("empty.title"))}</b>${esc(t("empty.body"))}<div><button class="btn primary" data-clear style="margin-top:16px">${esc(t("empty.action"))}</button></div></div>`;
  }

  function uniqueByHandle(items) {
    const seen = new Set();
    return (items || []).filter((item) => {
      const handle = item && item.handle;
      if (!handle || seen.has(handle)) return false;
      seen.add(handle);
      return true;
    });
  }

  function setMoreLoading(loading) {
    const button = $("#more");
    if (!button) return;
    button.disabled = Boolean(loading);
    if (loading) button.setAttribute("aria-busy", "true");
    else button.removeAttribute("aria-busy");
  }

  function syncMoreButton() {
    const results = $("#results");
    if (!results) return;
    const existing = results.querySelector(".loadmore");
    if (nextCursor != null) {
      if (existing) setMoreLoading(inflight);
      else results.insertAdjacentHTML("beforeend", moreButtonHtml(inflight));
    } else if (existing) {
      existing.remove();
    }
  }

  function selectedFacet(key, value) {
    if (key === "includePaused") return S.includePaused;
    return Array.isArray(S[key]) && S[key].includes(value);
  }

  function syncControlsFromState(data) {
    const source = data || lastData;
    root.querySelectorAll("[data-f]").forEach((input) => {
      const wanted = selectedFacet(input.dataset.f, input.value);
      input.checked = wanted;
      input.defaultChecked = wanted;
    });
    root.querySelectorAll("[data-inc]").forEach((input) => {
      input.checked = S.includePaused;
      input.defaultChecked = S.includePaused;
    });
    const search = $("#q");
    if (search && search.value !== S.q) search.value = S.q;
    const sort = $("#sort");
    if (sort && sort.value !== S.sort) sort.value = S.sort;
    root.querySelectorAll("[data-quick]").forEach((button) => {
      button.classList.toggle("on", S.quick === button.dataset.quick);
    });
    if (!source) return;
    const nextChips = activeChips(source);
    const existing = $("#results .active-filters");
    const head = $("#results .reshead");
    if (existing) {
      if (nextChips) existing.outerHTML = nextChips;
      else existing.remove();
    } else if (nextChips && head) {
      head.insertAdjacentHTML("afterend", nextChips);
    }
  }

  function renderFilterSurface(target, surface, data) {
    if (!target) return;
    target.setAttribute("autocomplete", "off");
    target.innerHTML = filterHTML(data).replaceAll('data-f="', `data-surface="${surface}" data-f="`);
  }

  function renderFilters(data) {
    renderFilterSurface($("#filters"), "desktop", data);
    renderFilterSurface($("#dbody"), "drawer", data);
    const chips = $("#chips");
    if (chips) {
      chips.innerHTML = [
        ["close", t("quick.close")],
        ...(showRecentChip ? [["recent", t("quick.recent")]] : []),
        ...(showNewChip ? [["new", t("quick.new")]] : []),
      ].map(([key, label]) => `<button type="button" class="chip ${S.quick === key ? "on" : ""}" data-quick="${key}">${esc(label)}</button>`).join("");
    }
    syncControlsFromState(data);
  }

  function render(data, append) {
    data = {
      ...data,
      items: (data.items || []).map(localizeItem),
      featuredItem: data.featuredItem ? localizeItem(data.featuredItem) : null,
      facets: localizeFacets(data.facets) || data.facets,
    };
    lastData = data;
    renderFilters(data);
    const results = $("#results");
    if (!results) return;

    if (append) {
      lastItems = uniqueByHandle(lastItems.concat(data.items || []));
      const grid = results.querySelector(".grid");
      const incoming = uniqueByHandle(data.items || []).filter((item) => !$$(".card[data-handle]").some((node) => node.getAttribute("data-handle") === item.handle));
      if (grid && incoming.length) grid.insertAdjacentHTML("beforeend", incoming.map(card).join(""));
      const count = results.querySelector(".reshead .n");
      if (count) {
        const total = data.totalCount || 0;
        count.textContent = total === 1 ? t("results.count", { n: total }) : t("results.count.plural", { n: total });
      }
      nextCursor = data.nextCursor != null ? data.nextCursor : null;
      S.cursor = typeof nextCursor === "number" ? nextCursor : S.cursor;
      syncMoreButton();
      return;
    }

    lastItems = uniqueByHandle(data.items || []);
    lastFeatured = data.featuredItem || null;
    nextCursor = data.nextCursor != null ? data.nextCursor : null;
    S.cursor = 0;
    const body = (lastItems.length || lastFeatured)
      ? `${featuredMarkup(lastFeatured)}<div class="grid" data-next-cursor="${nextCursor ?? ""}" data-total-count="${data.totalCount || 0}">${lastItems.map(card).join("")}</div>${nextCursor != null ? moreButtonHtml(false) : ""}`
      : emptyHtml();
    results.innerHTML = resultHead(data) + body;
  }

  function facetFromInput(input) {
    const count = input.parentElement?.querySelector(".cnt")?.textContent?.trim() || "";
    const label = (input.parentElement?.textContent || "").replace(count, "").trim();
    return { key: input.value, label, count: Number(count) || 0 };
  }

  function facetsFromDom() {
    return {
      cause: $$("#filters [data-f='cause']").map(facetFromInput),
      geography: [...$$("#filters [data-f='country']"), ...$$("#filters [data-f='region']")].map(facetFromInput),
      organizerType: $$("#filters [data-f='organizerType']").map(facetFromInput),
    };
  }

  function hydrateFromDom() {
    lastFeatured = $("#results .featured")
      ? { handle: $("#results .featured").getAttribute("data-handle") }
      : null;
    lastItems = $$("#results .card[data-handle]").map((node) => ({ handle: node.getAttribute("data-handle") }));
    const grid = $("#results .grid");
    const bakedCursor = grid?.getAttribute("data-next-cursor");
    nextCursor = bakedCursor ? Number(bakedCursor) : ($("#more") ? initialLimit : null);
    if (Number.isNaN(nextCursor)) nextCursor = $("#more") ? initialLimit : null;
    lastData = {
      ok: true,
      classificationRequired: [],
      items: lastItems,
      featuredItem: lastFeatured,
      totalCount: Number(grid?.getAttribute("data-total-count") || lastItems.length || 0),
      nextCursor,
      facets: facetsFromDom(),
    };
  }

  async function fetchDirectory(append) {
    if (append && (inflight || nextCursor == null)) return null;
    const cursor = append ? nextCursor : 0;
    inflight = true;
    requestSeq += 1;
    const seq = requestSeq;
    if (!append) resetCursor();
    setMoreLoading(true);
    try {
      const url = `${proxyUrl}?${queryString({ cursor: cursor || 0 })}`;
      const response = await fetch(url, { headers: { Accept: "application/json" }, cache: "no-store" });
      const data = await response.json();
      if (seq !== requestSeq) return null;
      if (!data.ok || !Array.isArray(data.classificationRequired)) {
        throw new Error(data.error || "directory_v11_unavailable");
      }
      try {
        if (!append) writeUrl();
      } catch {
        /* Keep rendering even if shareable URL updates are blocked. */
      }
      render(data, append);
      syncControlsFromState(data);
      return data;
    } catch (error) {
      lastError = error instanceof Error ? error.message : String(error);
      syncControlsFromState(lastData);
      throw error;
    } finally {
      if (seq === requestSeq) {
        inflight = false;
        setMoreLoading(false);
      }
    }
  }

  function clearFilters() {
    S.q = "";
    S.cause = [];
    S.country = [];
    S.region = [];
    S.organizerType = [];
    S.includePaused = false;
    S.quick = null;
    S.sort = "recommended";
    resetCursor();
    const search = $("#q");
    if (search) search.value = "";
    closeDrawer();
    syncControlsFromState(lastData);
    fetchDirectory(false).catch(() => {});
  }

  function openDrawer() {
    const drawer = $("#drawer");
    drawer.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.setAttribute("data-mkd-drawer-open", "true");
    $("#dclose")?.focus();
    trapFocus(drawer);
  }

  function closeDrawer() {
    const drawer = $("#drawer");
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.removeAttribute("data-mkd-drawer-open");
    $("#openDrawer")?.focus();
  }

  function trapFocus(drawer) {
    const nodes = [...drawer.querySelectorAll("button,input,select,a,[tabindex]:not([tabindex='-1'])")];
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    drawer.onkeydown = (event) => {
      if (event.key !== "Tab" || nodes.length === 0) return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
  }

  function applyDiscovery() {
    resetCursor();
    syncControlsFromState(lastData);
    return fetchDirectory(false);
  }

  root.addEventListener("click", (event) => {
    const quick = event.target.closest("[data-quick]");
    if (quick) {
      S.quick = S.quick === quick.dataset.quick ? null : quick.dataset.quick;
      applyDiscovery().catch(() => {});
      return;
    }
    if (event.target.closest("[data-clear]")) {
      clearFilters();
      return;
    }
    const remove = event.target.closest("[data-rm]");
    if (remove) {
      const [kind, value] = remove.dataset.rm.split(":");
      if (kind === "cause") S.cause = S.cause.filter((item) => item !== value);
      if (kind === "country") S.country = S.country.filter((item) => item !== value);
      if (kind === "region") S.region = S.region.filter((item) => item !== value);
      if (kind === "organizerType") S.organizerType = S.organizerType.filter((item) => item !== value);
      if (kind === "paused") S.includePaused = false;
      if (kind === "quick") S.quick = null;
      if (kind === "q") {
        S.q = "";
        const search = $("#q");
        if (search) search.value = "";
      }
      applyDiscovery().catch(() => {});
      return;
    }
    if (event.target.closest("#more")) {
      event.preventDefault();
      fetchDirectory(true).catch(() => {});
      return;
    }
    if (event.target.closest("#openDrawer")) {
      openDrawer();
      return;
    }
    if (event.target.closest("#dclose") || event.target.closest("#dapply")) {
      closeDrawer();
      return;
    }
    if (event.target.closest("#dclear")) {
      clearFilters();
    }
  });

  root.addEventListener("change", (event) => {
    const field = event.target.closest("[data-f]");
    if (field) {
      const key = field.dataset.f;
      const value = field.value;
      if (field.checked) {
        if (!S[key].includes(value)) S[key].push(value);
      } else {
        S[key] = S[key].filter((item) => item !== value);
      }
      applyDiscovery().catch(() => {});
      return;
    }
    if (event.target.matches("[data-inc]")) {
      S.includePaused = event.target.checked;
      applyDiscovery().catch(() => {});
      return;
    }
    if (event.target.id === "sort") {
      S.sort = event.target.value;
      applyDiscovery().catch(() => {});
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && $("#drawer")?.classList.contains("open")) closeDrawer();
  });

  $("#q")?.addEventListener("input", (event) => {
    S.q = event.target.value;
    applyDiscovery().catch(() => {});
  });

  window.addEventListener("popstate", () => {
    readUrl();
    syncControlsFromState(lastData);
    fetchDirectory(false).catch(() => {});
  });

  root.mayekooDirectory = {
    getState() {
      return {
        ...S,
        cause: [...S.cause],
        country: [...S.country],
        region: [...S.region],
        organizerType: [...S.organizerType],
        nextCursor,
        lastError,
        renderedHandles: lastItems.map((item) => item.handle),
        checkboxState: $$("[data-f]").map((input) => ({
          key: input.dataset.f,
          value: input.value,
          checked: input.checked,
          surface: input.closest("#dbody") ? "drawer" : "desktop",
        })),
        chipValues: $$("[data-rm]").map((button) => button.getAttribute("data-rm")),
      };
    },
    syncControlsFromState,
    queryString,
    resetCursor,
    applyDiscovery,
    fetchDirectory,
    hasDeliberateDiscovery,
    selectCountry(code) {
      if (!S.country.includes(code)) S.country.push(code);
      return applyDiscovery();
    },
  };

  readUrl();
  hydrateFromDom();
  syncRobots();
  if (!$("#dbody")?.innerHTML.trim() && $("#filters")?.innerHTML) {
    $("#dbody").innerHTML = $("#filters").innerHTML;
  }
  syncControlsFromState(lastData);
  fetchDirectory(false).catch(() => {});

  const closing = root.querySelector("[data-mkd-start]");
  if (closing && startUrl) closing.setAttribute("href", startUrl);
})();
